import format from 'date-fns/format';
import { TIME_VALUES, YEAR_FORMAT } from '../Constants/Date.constants';

export const getCurrentYear = () => {
  const currentDate = new Date();
  return format(currentDate, YEAR_FORMAT);
};

export const dateDiffInDays = (a: Date, b: Date) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / TIME_VALUES.DAY);
};
